import { toastr } from 'react-redux-toastr';
import { IFile } from '../../UI/FileList';
import { IAction } from '../../models/iaction';
import { IService } from '../../models/iservice';
import { fetchServiceById, updateService } from '../../services/services';
import * as actionTypes from '../actions/actionTypes';
import { i18n } from '../../translate/i18n';
// import { ISignature } from '../../containers/Services/EditService/SignatureModal';
// import { uploadSignature } from '../../utils/uploadSignature';
import { IOldAction } from '../../components/ServiceOldActionsPanel/ServiceOldActionsPanel';
import api from '../../axios/api';
import axios, { AxiosRequestConfig } from 'axios';
import { IActionSigned } from '../../models/iserviceQuestion';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';
import { selectUrl } from '../../axios/baseUrl';

const CancelToken = axios.CancelToken;
let getServiceFormActions_cancel: any;

interface IQuestionEdited {
  _id: string,
  questionsId: string,
  name: string,
  groupName: string,
  type: string,
  answer: string,
  // actions: IActionSigned[],
  comment: string,
  commentFlag: boolean,
  fileFlag: boolean,
  files: string[],
  weight: number,
  questionHadPendingActions: boolean,
}

export interface IUpdateServiceBody {
  date: Date;
  place: string;
  description: string;
  questions: IQuestionEdited[];
  files: string[];
  // signature: {
  //   name: string;
  //   document: string;
  //   file: string | null;
  // };
}

export const fetchServiceByIdStart = () => {
  return {
    type: actionTypes.EDIT_SERVICE_FETCH_SERVICE_START,
  }
}
  
export const fetchServiceByIdSuccess = (service: IService) => {
  return {
    type: actionTypes.EDIT_SERVICE_FETCH_SERVICE_SUCCESS,
    payload: service,
  }
}

export const fetchServiceByIdFail = () => {
  return {
    type: actionTypes.EDIT_SERVICE_FETCH_SERVICE_FAIL,
  }
}

export const editServiceFetchServiceById = (serviceId: string) => {
  return (dispatch: any) => {
    dispatch(fetchServiceByIdStart());
    fetchServiceById(serviceId)
    .then((res: any) => {
      dispatch(fetchServiceByIdSuccess(res.data));
    })
    .catch(() => {
      dispatch(fetchServiceByIdFail());
    });
  };
};

export const editServiceSelectService = (serviceId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_SELECT_SERVICE,
    payload: serviceId,
  }
}

export const editServiceChangeServiceDate = (date: Date) => {
  return {
    type: actionTypes.EDIT_SERVICE_CHANGE_SERVICE_DATE,
    payload: date,
  }
}

export const editServiceChangeServiceDescription = (descripion: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_CHANGE_SERVICE_DESCRIPTION,
    payload: descripion,
  }
}

export const editServiceChangeQuestionAnswer = (answer: string, questionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_CHANGE_QUESTION_ANSWER,
    payload: {
      answer,
      questionId,
    }
  }
}

export const editServiceChangeQuestionComment = (comment: string, questionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_CHANGE_QUESTION_COMMENT,
    payload: {
      comment,
      questionId,
    }
  }
}

export const editServiceAddQuestionAction = (action: IActionSigned, questionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_ADD_QUESTION_ACTION,
    payload: {
      action,
      questionId,
    }
  }
}

export const editServiceEditQuestionAction = (action: IActionSigned, questionId: string, actionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_EDIT_QUESTION_ACTION,
    payload: {
      action,
      questionId,
      actionId,
    }
  }
}

export const editServiceDeleteQuestionAction = (questionId: string, actionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_DELETE_QUESTION_ACTION,
    payload: {
      questionId,
      actionId,
    }
  }
}

export const editServiceAddQuestionFile = (files: IFile[], questionId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_ADD_QUESTION_FILE,
    payload: {
      files,
      questionId,
    }
  }
}

export const editServiceEditQuestionFile = (file: IFile, questionId: string, fileId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_EDIT_QUESTION_FILE,
    payload: {
      file,
      questionId,
      fileId,
    }
  }
}

export const editServiceDeleteQuestionFile = (questionId: string, fileId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_DELETE_QUESTION_FILE,
    payload: {
      questionId,
      fileId,
    }
  }
}

export const editServiceAddObservationFile = (files: IFile[]) => {
  return {
    type: actionTypes.EDIT_SERVICE_ADD_FILE,
    payload: {
      files,
    }
  }
}

export const editServiceEditObservationFile = (file: IFile, fileId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_EDIT_FILE,
    payload: {
      file,
      fileId,
    }
  }
}

export const editServiceDeleteObservationFile = (fileId: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_DELETE_FILE,
    payload: {
      fileId,
    }
  }
}

export const editServiceAnswerAllQuestionsNa = () => {
  return {
    type: actionTypes.EDIT_SERVICE_ANSWER_ALL_QUESTIONS_NA,
  }
}

export const editServiceRequestServicesStart = () => {
  return {
    type: actionTypes.EDIT_SERVICE_REQUEST_SERVICES_START
  };
};

export const editServiceRequestServicesFail = (error: string) => {
  return {
    type: actionTypes.EDIT_SERVICE_REQUEST_SERVICES_FAIL,
    error: error
  };
};

// export const deleteServicesSuccess = (service) => {
//   return {
//     type: actionTypes.DELETE_SERVICES_SUCCESS,
//     service: service
//   }
// }

// export const checkDeleteDocumentServicesSuccess = (checkDelete) => {
//   return {
//     type: actionTypes.CHECK_DELETE_SERVICES_SUCCESS,
//     checkDelete: checkDelete
//   }
// }

export const updateServicesSuccess = () => {
  return {
    type: actionTypes.EDIT_SERVICE_UPDATE_SERVICES_SUCCESS,
  }
}

// export const editServicesDeleteServices = (index) => {
//   return dispatch => {
//     return new Promise((resolve, reject) => {
//       dispatch(requestServicesStart());
//       API.put('/services/' + index + '/delete')
//         .then(res => {
//           dispatch(deleteServicesSuccess(res.data));
//           toastr.success(i18n.t('deleteServices.toastr'))
//           resolve('success');
//         })
//         .catch(err => {
//           dispatch(requestServicesFail(err));
//           toastr.error('Erro', err.response.data.message)
//           resolve('error');
//         });
//     })
//   }
// }

export const editServiceUpdateService = (serviceId: string, body: IUpdateServiceBody) => {
  return (dispatch: any) => {
    return new Promise((resolve, reject) => {

      dispatch(editServiceRequestServicesStart());
      updateService(serviceId, body)
        .then((res: any) => {
          dispatch(updateServicesSuccess());
          toastr.success(i18n.t('updateServices.toastr') as string, '');
          resolve('success');
        })
        .catch(err => {
          dispatch(editServiceRequestServicesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateServices.toastrError'), i18n.t('updateServices.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

// const addSignatureStart = () => {
//   return {
//     type: actionTypes.EDIT_SERVICE_ADD_SIGNATURE_START
//   }
// }

// const addSignatureSuccess = (signature: ISignature) => {
//   return {
//     type: actionTypes.EDIT_SERVICE_ADD_SIGNATURE_SUCCESS,
//     payload: {
//       signature
//     }
//   }
// }

// const addSignatureSFail = () => {
//   return {
//     type: actionTypes.EDIT_SERVICE_ADD_SIGNATURE_FAIL
//   }
// }

// export const editServiceAddSignature = (signature: ISignature | null) => {
//   return async (dispatch: any) => {
//     dispatch(addSignatureStart());
//     try {
//       const updateSignature = signature || { canvas: "", signatureId: null };
//       const res = await uploadSignature(signature);
//       if (res) {
//         updateSignature.signatureId = res.id;
//         updateSignature.url = res.url;
//       };
      
//       dispatch(addSignatureSuccess(updateSignature));
//       toastr.success('Assinatura adicionada com sucesso', "")
//       return 'success';
//     } catch (error) {
//       dispatch(addSignatureSFail());
//       toastr.error('Falha ao adicionar assinatura', "")
//       console.log(error)
//     }
//   }
// }

const fetchOldActionsStart = () => {
  return {
    type: actionTypes.EDIT_SERVICE_GET_OLD_ACTIONS_START,
  }
}

const fetchOldActionsSucess = (actions: IOldAction[]) => {
  return {
    type: actionTypes.EDIT_SERVICE_GET_OLD_ACTIONS_SUCCESS,
    payload: actions,
  }
}

const fetchOldActionsFail = () => {
  return {
    type: actionTypes.EDIT_SERVICE_GET_OLD_ACTIONS_FAIL,
  }
}

export const editServicefetchOldActions = (equipmentId: string, equipmentServiceId: string, serviceDate = '') => {
  getServiceFormActions_cancel && getServiceFormActions_cancel();

  return (dispatch: any) => {
    dispatch(fetchOldActionsStart());
    const beforeQuery = serviceDate !== '' ? `?before=${serviceDate}` : '';
    api.get(`/actions/oldactionsfornewservice/${equipmentId}/${equipmentServiceId}${beforeQuery}`, {
      cancelToken: new CancelToken(function executor(c) {
        getServiceFormActions_cancel = c;
      })
    })
      .then(res => {
        dispatch(fetchOldActionsSucess(res.data));
        // dispatch(editServiceFetchQuestions(equipmentServiceId, siteId, defaultAnswerNA));
      })
      .catch(err => {
        console.log(err)
        dispatch(fetchOldActionsFail());
      });
  };
}

export const editServiceClearState = () => {
  return {
    type: actionTypes.EDIT_SERVICE_CLEAR_STATE,
  }
}

const downloadReportStart = () => {
  return {
    type: actionTypes.EDIT_SERVICE_DOWNLOAD_REPORT_START,
  }
}

const downloadReportFail = () => {
  return {
    type: actionTypes.EDIT_SERVICE_DOWNLOAD_REPORT_FAIL,
  }
}

const downloadReportSuccess = () => {
  return {
    type: actionTypes.EDIT_SERVICE_DOWNLOAD_REPORT_SUCCESS,
  }
}

export const editServiceDownloadReport = (serviceId: string) => {
  return async (dispatch: any) => {
    dispatch(downloadReportStart());
    const localStorageLang = localStorage.getItem("i18nextLng");
    const language = formatLanguageFromLocalStorage(localStorageLang);
    try {
      toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
      const url = `${selectUrl()}/reports/service/${serviceId}/?language=${language}`;
      const response =  await api.get(url, { language } as AxiosRequestConfig);
      if (response.status === 200) {
        window.open(response.data.url);
        dispatch(downloadReportSuccess());
      }
    } catch (error) {
      toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
      dispatch(downloadReportFail());
    }
  }
}

export const editServiceDownloadExport = (serviceId: string) => {
  return async (dispatch: any) => {
    dispatch(downloadReportStart());
    const localStorageLang = localStorage.getItem("i18nextLng");
    const language = formatLanguageFromLocalStorage(localStorageLang);
    try {
      toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
      const url = `${selectUrl()}/reports/serviceExport/${serviceId}/?language=${language}`;
      const response =  await api.get(url, { language } as AxiosRequestConfig);
      if (response.status === 200) {
        window.open(response.data.url);
        dispatch(downloadReportSuccess());
      }
    } catch (error) {
      toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
      dispatch(downloadReportFail());
    }
  }
}